export interface Account {
  id: number;
  name: string
  timezone: string
  currency: string
  campaigns: Campaign[]
  customData: CustomData[]
  domains: Domain[]
  esps: Esp[]
  notifications: Notification[]
  widgets: Widget[]
}

interface Campaign {
  id: number
  name: string
  incentives: Incentive[]
  segments: Segment[]
  status: 'running' | 'draft'
}

interface CustomData {
  id: string
  type: string | null
  label: string | null
  description: string | null
}

interface Domain {
  id: number
  domain: string
}

interface Esp {
  id: number
  type: string
  name: string
}

interface Notification {
  id: number
  name: string
}

interface Incentive {
  id: number
  displayText: string
  promoCode: string
  status: 'active' | 'inactive'
}

interface Segment {
  id: number
  name: string
  status: 'active' | 'inactive' | 'disabled'
}

interface Widget {
  id: number
  name: string
  type: 'Default' | 'ExitIntent' | 'Smart'
  status: 'active' | 'archived'
}

export interface Stream {
  id: number
  accountId: number
  name: string
  eventType: string
  status: 'draft' | 'published' | 'deleted'
  isDisabled: boolean
  definition?: string
  updatedBy: number
  updatedOn: string
}

export async function getAccount(authKey: string): Promise<Account> {
  return fetch('https://api.fanplayr.com/filters', {
    headers: {
      'x-auth-key': authKey
    }
  })
  .then(res => res.json())
  .then(res => {
    const account: Account = {
      id: res.id,
      name: res.name,
      timezone: res.timezone,
      currency: res.currency,
      campaigns: res.campaigns,
      customData: res.customData,
      domains: res.domains,
      esps: (res.esps || []).map((d: any) => {
        const data = JSON.parse(d.config)
        return {
          id: d.id,
          type: data.espName,
          name: data.name
        }
      }),
      notifications: res.notifications,
      widgets: res.widgets
    }
    return account
  })
}
